import { useState, useEffect } from 'react';

const INTRO = "Hi there! Thanks for stopping by. My research focuses on using computational tools to understand human behavior in digital spaces. I am passionate about fostering healthier online communities and digital dialogue.";

export default function About() {
  const [typed, setTyped] = useState('');

  useEffect(() => {
    let i = 0;
    const start = setTimeout(() => {
      const timer = setInterval(() => {
        i++;
        setTyped(INTRO.slice(0, i));
        if (i >= INTRO.length) {
          clearInterval(timer);
        }
      }, 14);
      return () => clearInterval(timer);
    }, 1000);
    return () => clearTimeout(start);
  }, []);

  return (
    <section className="hero">
      <div className="hero-content">
        <div className="hero-text">
          <h1 className="hero-name">
            Xiaoyi <span className="accent">(Mimi)</span> Chen
          </h1>
          <p className="hero-role">studying people & systems</p>
          <h2 className="code-header">
            <span className="keyword">print</span>
            <span className="punctuation">(</span>
            <span className="string">"about"</span>
            <span className="punctuation">)</span>
          </h2>
          <p className="hero-desc">
            {typed}<span className="cursor" />
          </p>
        </div>

        <div className="hero-image-container">
          <div className="hero-image-wrap">
            <img
              src="/header_photo.jpg"
              alt="Portrait of Mimi Chen"
              className="hero-image"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
